"use strict";

var Backbone = require('backbone');
var _ = require('underscore');
var Bed = require("./bed");

var CRIB=0, SINGLE_AIRBED=1, DOUBLE_AIRBED=2;

var Room = Backbone.Model.extend({
  _isBedroom: function(){
    var beds = this.get('beds');

    // if there is any permanent bed in the room, we consider it a bedroom
    return _(beds).any(function(bed){
      return bed.get('category') === "permanent";
    });
  },

  _getAirbedSpacesLeft: function(){
    var beds = this.get('beds');
    var count = 0;

    _(beds).each(function(bed){
      if(bed.get('extra_id') === SINGLE_AIRBED || bed.get('extra_id') === DOUBLE_AIRBED){
        count += bed.getSelectedCount();
      }
    });

    return this.get('airbed_sleeps') - count;
  },

  _getSleepsLeft: function(){
    return this.get('bedConfiguration').getSleepsLeft();
  },

  wasCribAdded: function(){
    var beds = this.get('beds');
    return _(beds).any(function(bed){
      return bed.get('extra_id') === CRIB;
    });
  },

  getAirbeds: function(){
    var beds = this.get('beds');
    return beds.filter(function(bed){
      return bed.get('bed_type') === 'AirBed';
    });
  },

  getNormalBeds: function(){
    var beds = this.get('beds');
    return beds.filter(function(bed){
      return bed.get('bed_type') !== 'AirBed' && bed.get('bed_type') !== 'Crib';
    });
  },

  _isCribAvailable: function(){
    if(this.wasCribAdded()){
      return false;
    }

    if(this._getSleepsLeft() < 1){
      return false;
    }

    return true;
  },

  _isAirbedAvailable: function(spacesNeeded){
    return this._getAirbedSpacesLeft() >= spacesNeeded &&
           this._getSleepsLeft() >= 1;
  },

  _getPriceFor: function(extra_id){
    var bedBillables = this.get('bedConfiguration').get('bed_billables');

    if(!bedBillables){
      return null;
    }

    switch(extra_id){
      case CRIB:
        return bedBillables['crib'];
      case SINGLE_AIRBED:
        return bedBillables['airbed (single)'];
      case DOUBLE_AIRBED:
        return bedBillables['airbed (double)'];
    }
  },

  addExtra: function(extra_id, selected){
    var newBed;

    switch(extra_id){
      case CRIB:
        newBed = {
          bed_type: "Crib",
          category: "temporary",
          label: "Crib",
          size: "CHILD",
          sleeps: 1,
          selected: 1,
          extra_id: CRIB,
          isExtra: true
        };
        break;
      case SINGLE_AIRBED:
        newBed = {
          bed_type: "AirBed",
          category: "temporary",
          label: "Single airbed",
          size: "SINGLE",
          sleeps: 1,
          selected: 1,
          extra_id: SINGLE_AIRBED,
          isExtra: true,
        };
        break;
      case DOUBLE_AIRBED:
        newBed = {
          bed_type: "AirBed",
          category: "temporary",
          label: "Double airbed",
          size: "DOUBLE",
          sleeps: 2,
          // if a selected value is given, use it (only ever happens when server data is parsed back)
          selected: selected || (this._getSleepsLeft() > 1 ? 2 : 1),
          extra_id: DOUBLE_AIRBED,
          isExtra: true,
        };
    }

    newBed.bedConfiguration = this.get('bedConfiguration');
    newBed.price = this._getPriceFor(extra_id);
    newBed.room = this;

    this.get('beds').push(new Bed(newBed));

    this.get('bedConfiguration').trigger('change');
  },

  getAvailableExtras: function () {
    var extras = [];
    var isBedroom = this._isBedroom();
    var airbedSleeps = this.get('airbed_sleeps');

    if(isBedroom){
      extras.push({
        name: "crib",
        price: this._getPriceFor(CRIB),
        extra_id: CRIB,
        active: this._isCribAvailable()
      });
    }

    if(airbedSleeps >= 1){
      extras.push({
        name: "single airbed",
        price: this._getPriceFor(SINGLE_AIRBED),
        extra_id: SINGLE_AIRBED,
        active: this._isAirbedAvailable(1)
      });
    }

    if(airbedSleeps >= 2){
      extras.push({
        name: "double airbed",
        price: this._getPriceFor(DOUBLE_AIRBED),
        extra_id: DOUBLE_AIRBED,
        active: this._isAirbedAvailable(2)
      });
    }

    return extras;
  }
});

module.exports = Room;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/models/room.js
 **/